import { Outlet, useLocation } from "react-router-dom";
import { propertiesRoutes } from "../../../app/routes";
import { selectInitializeToken } from "../../../app/slices/authSlice";
import { useTypedSelector } from "../../../app/stores/store";
import RightMenu from "../../../components/rightMenu/RightMenu";
import InterestCalculation from "../../../features/activeLoans/InterestCalculation";
import { getItemsFromObject } from "../../../services/array/transformObject";
import { selectShowInterestCalculation } from "../../activeLoans/activeLoansSlice";

function MainLayout() {
  const { pathname } = useLocation();
  const showInterestCalculation = useTypedSelector(selectShowInterestCalculation);
  const initializeToken = useTypedSelector(selectInitializeToken);
  const itemRoutes = getItemsFromObject(propertiesRoutes);

  return (
    <main className="container container-max mw-text">
      <div className="row has-spinner relative">
        <article id="main-content" className="col-lg-8 col-md-7 col-sm-12 bg-white blue-square p-4">
          <Outlet />
        </article>
        <aside id="right-menu" className="col-lg-4 col-md-5 overflow-hidden px-md-4 p-0">
          <div className="bg-white p-4">
            <span>{`${initializeToken?.citizen_firstname} ${initializeToken?.citizen_lastname}`}</span>
          </div>
          <div className="row spacer" />
          <RightMenu routes={itemRoutes} />
          {pathname === propertiesRoutes.activeLoans.path && showInterestCalculation ? (
            <>
              <div className="row spacer" />
              <div className="bg-white px-4">
                <InterestCalculation />
              </div>
            </>
          ) : undefined}
        </aside>
      </div>
    </main>
  );
}

export default MainLayout;
